export function getUtilityLabelFromAssistanceApplicationAreasOfNeed(areasOfNeed: any): string {
    const selectedOptions = Object.entries(areasOfNeed)
        .filter(([key, val]) => val)
        .map(([key]) => {
            switch (key) {
                case 'uhonsElectric':
                    return 'Electric';
                case 'uhonsGasHeat':
                    return 'Gas/Heat';
                case 'uhonsSewer':
                    return 'Sewer';
                case 'uhonsWater':
                    return 'Water';
                default:
                    return '';
            }
        })
        .filter(label => label !== '')
        .join('/');

    return selectedOptions ? `Utility Bill(s) (${selectedOptions})` : 'Utility Bill(s)';
}
